module.exports = __webpack_public_path__ + "static/media/seguro_vehiculo.635b310f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/seguro_vehiculo.jpg
// module id = 366
// module chunks = 0